import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-content-info d-flex align-items-center justify-content-between" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { style: {"color":"red"} }
const _hoisted_9 = {
  key: 0,
  class: "modal"
}
const _hoisted_10 = { class: "modal-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_button = _resolveComponent("b-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[9] || (_cache[9] = _createElementVNode("h2", null, "Подписание отчетов", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _cache[4] || (_cache[4] = _createTextVNode("Найдено: ")),
        _createElementVNode("span", null, _toDisplayString(_ctx.totalCount), 1)
      ])
    ]),
    _createVNode(_component_b_pagination, {
      modelValue: _ctx.currentPage,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
      "total-rows": _ctx.totalCount,
      "per-page": _ctx.pageSize
    }, null, 8, ["modelValue", "total-rows", "per-page"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.kindergartenCalculationReports,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          label: "#",
          width: "50"
        }),
        _createVNode(_component_el_table_column, {
          prop: "accountingMonth",
          label: "Расчетный месяц"
        }),
        _createVNode(_component_el_table_column, {
          prop: "accountingYear",
          label: "Расчетный год"
        }),
        _createVNode(_component_el_table_column, { label: "Название файла" }, {
          default: _withCtx((scope) => [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.handleDownload(scope.row.report.uuid, scope.row.report.fileName)),
              class: _normalizeClass({ 'active-link': scope.row.report.reportStatus === 'GENERATED', 'error-link': scope.row.report.reportStatus === 'ERROR' })
            }, _toDisplayString(scope.row.report.fileName), 11, _hoisted_2)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Статус" }, {
          default: _withCtx((scope) => [
            (scope.row.signStatus === 'SIGNED')
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Подписан"))
              : _createCommentVNode("", true),
            (scope.row.signStatus === 'REJECTED_BY_HEAD')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Отклонен"))
              : (scope.row.signStatus === 'NOT_SIGNED')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_ctx.hasAllowanceToSign(scope.row.lmsId))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (!_ctx.isSaving)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                onClick: ($event: any) => (_ctx.onClickSignDocument(scope.row.report.uuid))
                              }, {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                  _createTextVNode(" Подписать ")
                                ])),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                disabled: ""
                              }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                  _createTextVNode("Загрузка...")
                                ])),
                                _: 1
                              })),
                          _createVNode(_component_el_button, {
                            type: "danger",
                            onClick: ($event: any) => (_ctx.onClickShowRejectDocumentModal(scope.row.id))
                          }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode(" Отказать ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.textProhibitionToSign(scope.row.lmsId)), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.isLoading]
    ]),
    (_ctx.showRejectDocumentModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Отказ от подписание документа", -1)),
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClickRejectDocument && _ctx.onClickRejectDocument(...args)), ["prevent"]))
            }, [
              _createVNode(_component_b_form_group, { label: "Укажите причину отказа" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_textarea, {
                    modelValue: _ctx.rejectComment,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rejectComment) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_b_button, {
                type: "submit",
                variant: "primary",
                disabled: _ctx.isSaving
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isSaving ? 'Сохраняется...' : 'Сохранить'), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ], 32),
            _createElementVNode("button", {
              class: "close-modal-btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
            }, "Закрыть")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}